import React from "react";
import { useGlobalContext } from "../context";
import { useParams } from "react-router-dom";

const DishDetail = () => {
  const { id } = useParams();
  const { dishes } = useGlobalContext();
  const dish = dishes.find((item) => {
    return id == item.id;
  });

  if (!dish) {
    return (
      <section className="detail-empty">
        <h2>{`Dish with id number ${id} does not exist`}</h2>
      </section>
    );
  }
  const { name, img, supplements } = dish;
  let supp = "";
  supplements.forEach((item, index) => {
    if (index < supplements.length - 1) {
      supp += item += ", ";
    } else {
      supp += item;
    }
  });

  return (
    <section className="detail">
      <img src={img} alt={name} className="detail-img" />
      <aside className="detail-groups">
        <div className="detail-group">
          <h3>Name:</h3>
          <p>{name}</p>
        </div>
        <div className="detail-group">
          <h3>Content:</h3>
          <p>{supp}</p>
        </div>
        {/* <div className="detail-group">
          <h3>Price Per Plate:</h3>
          <p>{`N${price}`}</p>
        </div> */}
      </aside>
    </section>
  );
};

export default DishDetail;
